<template>
	<div class="payMinHeight">
		<div v-html="apply"></div>
	</div>
</template>

<script>
	let _self;
	export default {
		name: "ZfbPay",
		data() {
			return {
				apply:'',
			}
		},
		beforeCreate() {
			_self = this;
		},
		created() {
			this.$EventBus.$emit('AppCloseNav', true);
			// 判断页面传参信息
			try{
				// 解码获取的路由参数
				let pageVal=decodeURIComponent(_self.$router.history.current.query.info);
				// json化数据
				let jxVal=JSON.parse(pageVal || '{}');
				// 判断页面是否有传值信息
				if(pageVal && jxVal){
					// console.log('页面传递参数===',jxVal);
						
					this.apply = jxVal;
				}else{
					_self.$eror('订单信息错误！')
					// 无页面传值===返回首页
					_self.$router.replace({name:'/'});
				}
			}catch(err){
				_self.$eror('商品信息错误。')
				// 出现错误的情况下===》跳转回首页
				_self.$router.replace({name:'/'});
			}
			
			// let form = this.$route.query.htmls;
			// console.log('页面穿肚信息===',form);
		},
		// 方法集
		methods: {
			
		},
		// 组件集
		components: {
			
		},
		mounted() {
			setTimeout(() => {
				document.forms[0].submit();
			}, 1000)
		},
		watch: {
			
		},
		computed: {
			
		},
		// 过滤器
		filters: {
			
		},
		// 实例销毁
		destroyed() {
			
		},
		// 页面跳转信息
		beforeRouteEnter(to, from, next) {
			let info = localStorage.getItem('userInfo');
			info ? next() : next('/Login')
		},
	}
</script>
<style lang="scss">
	.payMinHeight{
		width: 1200px;
		min-height: 100Vh;
		margin: 0 auto;
	}
</style>
